import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authLogout } from '../../store/modules/auth/actions';

const NavBar = () => {
	const { isAuthenticated } = useSelector((state) => state.auth);
	const [show, setShow] = useState(false);
	const dispatch = useDispatch();

	const toogleMenu = (e) => {
		e.preventDefault();
		setShow(!show);
	}
	return (
		<nav className="navbar" role="navigation" aria-label="main navigation">
			<div className="navbar-brand">
				{/* <a className="navbar-item" href="https://bulma.io">
				<img src="https://bulma.io/images/bulma-logo.png" width="112" height="28" />
			</a> */}
				<a className="navbar-item" href="/">
					<img src="Brasao_logo.png" alt="Prefeitura de Indaiatuba" width="30" height="45" />
				</a>

				<span role="button" onClick={toogleMenu} className={show ? "navbar-burger burger is-active" : "navbar-burger burger"} aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</span>
			</div>

			<div id="navbarBasicExample" className={show ? "navbar-menu is-active" : "navbar-menu"}>
				<div className="navbar-start">
					<NavLink to="/" className="navbar-item" activeClassName="is-active" exact>Home</NavLink>
					<a href="/doc" className="navbar-item">Documentação</a>
					{isAuthenticated && (
						<NavLink to="/anexo" className="navbar-item" activeClassName="is-active">Anexos</NavLink>
					)}
					{/* {isAuthenticated && (
						<NavLink to="/requerimento" className="navbar-item" activeClassName="is-active">Requerimentos</NavLink>
					)} */}
					{/* <NavLink to="/anexo" className="navbar-item" activeClassName="is-active">Anexo</NavLink> */}
					{/* <a href="#" className="navbar-item">
						Documentation
					</a>
					<div className="navbar-item has-dropdown is-hoverable">
						<a href="#" className="navbar-link">
							More
						</a>
						<div className="navbar-dropdown">
							<a href="#" className="navbar-item is-active">
								About
							</a>
							<a href="#" className="navbar-item">
								Jobs
							</a>
							<a href="#" className="navbar-item">
								Contact
							</a>
							<hr className="navbar-divider" />
							<a href="#" className="navbar-item">
								Report an issue
							</a>
						</div>
					</div> */}
				</div>
				<div className="navbar-end">
					<div className="navbar-item">
						<div className="buttons">
							{!isAuthenticated && (
								<>
									<Link to={`/cadastro`} className="button is-primary">Cadastrar</Link>
									<Link to={`/login`} className="button is-light">Login</Link>
								</>
							)}
							{isAuthenticated && (
								<Link to={`/`} className="button is-warning" onClick={() => { dispatch(authLogout()) }}>Sair</Link>
							)}
						</div>
					</div>
				</div>
			</div>
		</nav>
	);
};

export default NavBar;